var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-photo",class:_vm.userPhotoSize},[(_vm.image)?_c('div',{staticClass:"user-photo__image-wrapper"},[_c('img',{staticClass:"user-photo__image",attrs:{"src":_vm.image,"alt":"User photo"}})]):_c('div',{staticClass:"user-photo__no-image"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }